module.exports = __webpack_public_path__ + "static/img/faq_service06.d6a3f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service06.png
// module id = WdOA
// module chunks = 2